import { BaseEntity } from '@/remoteApi/EntityApi';
import { Attachment, Relation } from '@/types';
import { ProductType } from '@/remoteApi/ProductTypeApi';

export enum QuestionType {
	SELECT = 'SELECT',
	MODAL_PICKER = 'MODAL_PICKER',
	TEXT = 'TEXT',
	FILES = 'FILES',
	NUMBER = 'NUMBER',
	TEXTAREA = 'TEXTAREA',
	DIMENSIONS = 'DIMENSIONS',
	ADVANCED_OPTIONS = 'ADVANCED_OPTIONS',
	MODEL_PICKER_TYPE = 'MODEL_PICKER_TYPE',
}

export interface Answer extends BaseEntity {
	question: Question;
	name: string;
	description?: string;
	image?: Attachment;
	listOrder: number;
	minTotalSurface: number;
	relations: Relation[];
}

export interface Question extends BaseEntity {
	questionGroup: QuestionGroup;
	name: string;
	description?: string;
	suffix: string;
	questionType: QuestionType;
	listOrder: number;
	answers: Answer[];
	relations: Relation[];
	placeholder: string;
}

export interface QuestionGroup extends BaseEntity {
	formTemplate: FormTemplate;
	name: string;
	description: string;
	image?: Attachment;
	listOrder: number;
	questions: Question[];
}

export interface FormTemplate extends BaseEntity {
	productType: ProductType;
	questionGroups: QuestionGroup[];
}